import { Component } from '@angular/core';
import { PageHeroComponent } from "../../../../shared/components/page-hero/page-hero.component";

@Component({
  selector: 'app-hero-about',
  imports: [PageHeroComponent],
  templateUrl: './hero-about.component.html',
  styleUrl: './hero-about.component.css',
})
export class HeroAboutComponent {

}
